export default "__VITE_ASSET__kH2oiPay__"